import { render, staticRenderFns } from "./shengheModal.vue?vue&type=template&id=663a6d69&"
import script from "./shengheModal.vue?vue&type=script&lang=js&"
export * from "./shengheModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports